import React from 'react';
import {Route, Redirect} from 'react-router-dom';

const PrivateRoute = (props) => {
    return localStorage.getItem('user') ? <Route path={props.path} name={props.name} component={props.component}/> : <Redirect to={{pathname: '/login', state: {from: props.location}}}/>
}
export {PrivateRoute};
